import { render } from "./TextAvatarSizeSimpleRoundedExample.vue?vue&type=template&id=7ffcc05b&ts=true"
import script from "./TextAvatarSizeSimpleRoundedExample.vue?vue&type=script&lang=ts"
export * from "./TextAvatarSizeSimpleRoundedExample.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__